import { Money } from '@/models/money';
import { TextField, TextFieldProps } from '@mui/material';
import { ChangeEvent, FunctionComponent } from 'react';

export type MoneyInputProps = Omit<
    TextFieldProps,
    'value' | 'defaultValue' | 'onChange'
> & {
    value: Money;
    defaultValue?: Money;
    onChange: (nextValue: Money, e: ChangeEvent) => void;
};

export const MoneyInput: FunctionComponent<
    React.PropsWithChildren<MoneyInputProps>
> = ({ value, onChange, ...props }) => {
    return (
        <TextField
            {...props}
            variant='filled'
            type='number'
            autoComplete='off'
            value={value?.amount || ''}
            onChange={(e: React.ChangeEvent) => {
                const { value } = e.target as HTMLInputElement;
                onChange(
                    {
                        amount: parseFloat(value),
                        currency: 'EUR',
                    },
                    e
                );
            }}
        />
    );
};
